import { Config } from "../landing-config";
import { ico_picked } from "../map-config";


const maxFileRows = 500;
export const PUNTI_INTERMEDI_CONFIG: Config = {
    data: {
        route: 'punti-intermedi',
        page_title: 'Rilegamento Punti Intermedi | Open Fiber',
        service_title: 'Rilegamento Punti Intermedi',
        service_description: '',
        service_name: '',
        service_slug: 'puntiintermedi',
        errorTimeout: 10000,
        feasibilityModelSingle: false,
        feasibilityEnabled: true,
        api: {
            massiveImport: {
                massiveDetailsPath: '/serviziopuntiintermedi/massivep2p/detail',
                massiveUploadPath: '/point/serviziopuntiintermedi/massivep2p/upload',
                massiveDownloadPath: '/serviziopuntiintermedi/data/massive/import.xlsx',
                massiveP2pSalesforcePath: '/serviziopuntiintermedi/massivep2p/send-to-salesforce',
                max_file_rows: maxFileRows,
                info_message: null
            },
            p2pPath: '/point/serviziopuntiintermedi/p2p',
			bboxPath: null,
			buildingSearchParams: null
        },
        dynamic_aend_name: ''
    },
    multiple_points: {
        variable: false,
        max: 1,
        points: {
            b_end: {
                default_method: 'punti_intermedi',
                switch_methods: true,
                address: false,
                pop: false,
                poi: false,
                pfs: false,
                roe: false,
                coordinates: false,
                id_building: false,
                id_bts_noa: false,
                id_bts_building: false,
                id_school: false,
                city_noa: false,
                city_pop: false,
                city_poi: false,
				city_building: false,
				city_pfs: false,
				city_roe: false,
                id_healthcare: false,
                upload: true,
                popAndPoiAutocomplete: false,
				punti_intermedi: true,
				rete: false,
                pop_pcn_xpop: false,
            },
            a_end: null
        },
        initial_points: ['b_end']
    },
    map: {
        map_events: ['zoom_changed', 'bounds_changed', 'dragend', 'dblclick'],
        marker_has_label: false,
        marker_default_icon: ico_picked,
        clear_markers_zoom_level: 16
    },
    research_methods: {
        id_building: false,
        id_bts_noa: false,
        id_bts_building: false,
        id_school: false,
        id_healthcare: false,
        punti_intermedi: true,
        pop_pcn_xpop: false,
    },
    area_types: ['CoveredCD'],
    area_types_short: ['C%26D'], // TODO encode
    kml: false,
    pop: {
        load: false,
        view_initial: false,
        click: false,
        loadCities: false
    },
    pcn: {
        load: false,
        view_initial: false,
        click: false
    },
    pop_agf: {
        load: false,
        view_initial: false,
        click: false
    },
    poi: {
        load: false,
        view_initial: false,
        click: false,
        x_pop: false,
        is_registered: false,
        custom_research_method: 'Address',
        loadCities: false
    },
    pfs: {
        load: false,
        view_initial: false,
        click: false,
        type: 'PFS'
    },
    roe: {
        load: true,
        view_initial: true,
        click: true,
        type: 'ROE'
    },
    cno: {
        load: true,
        view_initial: true,
        click: true,
        type: 'CNO'
    },
    pozzetto: {
        load: true,
        view_initial: true,
        click: true,
        type: 'POZZETTO'
    },
    building: {
        load: false,
        click: false,
        placeholder: 'Insert Building ID'
    },
    noa: {
        load: false,
        click: false,
        placeholder: 'Insert NOA ID'
    },
    bts: {
        load: false,
        types: null
    },
    punti_intermedi: {
        load: true,
        types: {
            ROE: {
                load: true,
                click: true,
            },
            CNO: {
                load: true,
                click: true,
            },
            POZZETTO: {
                load: true,
                click: true,
            }
        }
    },
    pop_pcn_xpop: {
        load: false,
        types: null
    },
    school: {
        load: false,
        click: false,
        placeholder: 'Insert School ID'
    },
    healthcare: {
        load: false,
        click: false,
        placeholder: 'Insert Healthcare ID'
    }
}